import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import type { CustomerComplianceAlert } from '@/lib/customer-types'

/** Badge tone from a defect severity / priority string. Null-safe. */
function severityVariant(value: string | null | undefined): 'critical' | 'high' | 'normal' | 'low' {
  const s = (value ?? '').toLowerCase()
  if (/(immediate|danger|critical)/.test(s)) return 'critical'
  if (/(high|major|urgent)/.test(s)) return 'high'
  if (/(low|minor|advisory)/.test(s)) return 'low'
  return 'normal'
}

export function CustomerComplianceSection({
  alerts,
}: {
  alerts: CustomerComplianceAlert[]
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Compliance alerts · {alerts.length}</CardTitle>
      </CardHeader>
      <CardContent>
        {alerts.length === 0 ? (
          <p className="text-sm text-cmd-outline">No active compliance alerts.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-cmd-highest text-left font-label text-[0.65rem] uppercase tracking-wider text-cmd-outline">
                  <th className="py-2 pr-4">Vehicle</th>
                  <th className="py-2 pr-4">Severity</th>
                  <th className="py-2 pr-4">Description</th>
                  <th className="py-2 text-right">Age</th>
                </tr>
              </thead>
              <tbody>
                {alerts.map((a, i) => (
                  <tr
                    key={a.id}
                    className={`border-b border-cmd-highest/50 ${
                      i % 2 === 0 ? 'bg-cmd-surface' : 'bg-cmd-low'
                    }`}
                  >
                    <td className="py-2 pr-4 font-mono text-xs uppercase text-primary">
                      {a.vehicleRegistration}
                    </td>
                    <td className="py-2 pr-4">
                      <Badge variant={severityVariant(a.severity ?? a.priority)}>
                        {a.severity ?? a.priority}
                      </Badge>
                    </td>
                    <td className="py-2 pr-4 text-white/80">{a.description}</td>
                    <td className="py-2 text-right font-mono tabular-nums text-cmd-outline">
                      {a.ageDays}d
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
